import './help-link.styles.scss';
import { Link } from 'react-router-dom';

// A small "?" that opens a section of the How it works page.
// section: the section id, e.g. "chemistry". label: what it explains.
const HelpLink = ({ section, label }) => (
    <Link to={`/how-it-works#${section}`} className='help-link' aria-label={label} title={label}>?</Link>
);

export default HelpLink
